import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal } from "bootstrap";
import { formatTime } from "../../../Layout/Common/common";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { ValidationErrorMessage } from "../../../Layout/Common/alert/validationErrorMessage";

export const OtpVerificationPopup = ({ show, address, onhide }) => {
  const modalRef = useRef(null);
  const modalInstance = useRef(null);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);
  const [timeLeft, setTimeLeft] = useState(300);
  const [errorMessage, setErrorMessage] = useState("");
  const { showFlashScreen, showModelAlert } = useNoteAlert();
  const { sendAddressUpdateOTP, updateAddressMail } = useGlobalFunction();
  useEffect(() => {
    if (modalRef.current) {
      modalInstance.current = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
    }
    if (show) {
      handleShow();
    }
  }, [show]);

  useEffect(() => {
    if (timeLeft <= 0) {
      //clearOtp();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);
  const handleShow = () => {
    modalInstance.current?.show();
  };

  const handleHide = () => {
    modalInstance.current?.hide();
    setOtp(["", "", "", "", "", ""]);
    setTimeLeft(300);
    onhide(false);
  };
  const handleResend = async () => {
    try {
      showFlashScreen(true);
      await sendAddressUpdateOTP();
      setTimeLeft(300);
      setOtp(["", "", "", "", "", ""]);
      showFlashScreen(false);
    } catch (e) {
      showFlashScreen(false);
    }
  };
  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input automatically
    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }
    setErrorMessage("");
  };

  const handleKeyDown = (e, index) => {
    if (e.key == "Backspace" && !otp[index] && index > 0) {
      // Move back if empty and backspace
      inputsRef.current[index - 1].focus();
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").trim();
    if (!/^\d+$/.test(paste)) return; // only digits allowed

    const digits = paste.split("").slice(0, otp.length); // limit to input length
    const newOtp = [...otp];

    digits.forEach((digit, i) => {
      newOtp[i] = digit;
      if (inputsRef.current[i]) {
        inputsRef.current[i].value = digit;
      }
    });

    setOtp(newOtp);

    // Move focus to last filled input
    const lastIndex = digits.length - 1;
    if (lastIndex >= 0 && lastIndex < otp.length) {
      inputsRef.current[lastIndex].focus();
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    var response = await updateAddressMail(otp.join(""), address);
    if (response == "OTP FAILD") {
      setErrorMessage("OTP Verification Failed. Try again.");
    } else {
      handleHide();
      showModelAlert({
        content: `<p class="text-center col-fs-14 fs-15 fw-normal">Address update has been submitted to us successfully. Please allow
                                    <b>One business day</b> for your details to be updated.</p>`,
        title: "Address Update Submitted",
        showCloseBtn: false,
        icon: "wes-address-home",
      });
    }
  };

  const isOtpComplete = otp.every((digit) => digit != "");
  return (
    <div
      className="modal fade"
      id="addFavModal"
      tabIndex={-1}
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
      ref={modalRef}
    >
      <div className="modal-dialog modal-dialog-centered modal-animate-center product-notfound-dialog">
        <div className="modal-content">
          <p className="order-status-close" data-bs-dismiss="modal" onClick={handleHide}>
            <i className="fa-regular fa-circle-xmark" />
          </p>
          <div className="modal-body p-0">
            <div className="product-found">
              <div className="product-found-title">
                <span className="wes-fav-lists" />
                <h4>OTP Verification</h4>
              </div>
              <div className="commonPopup-body acc-shipping-update">
                <div className="acc-shippingUpdate-title text-center">
                  <h5 className="fw-medium">Enter OTP</h5>
                  <p className="fs-14 fw-normal">We have sent a verification code to yout email.</p>
                  <div className="d-flex justify-content-center gap-2  mb-2">
                    {otp.map((val, index) => (
                      <input
                        key={index}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={val}
                        ref={(el) => (inputsRef.current[index] = el)}
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onPaste={index == 0 ? handlePaste : undefined}
                        className="form-control text-center"
                        style={{ width: "50px", fontSize: "24px" }}
                      />
                    ))}
                  </div>
                  <p className="fs-14 fw-normal">
                    Don't receive the code?
                    <a href="#" onClick={handleResend}>
                      {" "}
                      Resend code
                    </a>
                  </p>
                  <div className="text-center mt-3">
                    <p style={{ fontWeight: "bold", fontSize: "14px" }}>Time Remaining: {formatTime(timeLeft)}</p>
                  </div>
                </div>
                <ValidationErrorMessage
                  handleHidden={() => {
                    setErrorMessage("");
                  }}
                  message={errorMessage}
                />
                <div className="col-lg-12 mt-3 acc-shipp-button">
                  <div className="popupBtns mt-4">
                    <div className="button-effect popupBtns-one">
                      <button
                        type="submit"
                        className="btn btn-products theme-primary"
                        onClick={handleSubmit}
                        disabled={!isOtpComplete || timeLeft <= 0}
                      >
                        <i className="fa-solid fa-check" /> Verify Code
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
